import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const DomainSearchSuiteBIExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=DomainSearchSuiteBIExtension.js.map